import React from 'react';
import styled from "styled-components";
import PreviewTag from "@/components/common/Preview/Tag";
import ABVariantButton from "@/components/common/Preview/ABVariantButton";

const Wrapper = styled.div`
    position: fixed;
	display: flex;
	flex-direction: column;
    right: 20px;
    bottom: 25px;
	width: fit-content;
    gap: 10px;
    z-index: 1000;
`

const Preview = () => {
	return (
		<Wrapper>
			<ABVariantButton />
			<PreviewTag />
		</Wrapper>
	);
};

export default Preview;
